// extracted by mini-css-extract-plugin
export default {"bubble":"level_bubble__mGrd6","pulse":"level_pulse__sdskz","primitive":"level_primitive__GFN4K"};